/* eslint-disable  */

import { api } from './api';

export const pshychologicalAssessment = api.injectEndpoints({
    endpoints: (builder) => ({
        //-----------------------------------------------------------------
        //------------------------------------------------------------------

        getPatientLocation: builder.query({
            query: (payload) => ({
                url: 'api/therapy/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'patientlocation'
                }
            })
        }),

        getPsychologicalTherapistList: builder.query({
            query: (payload) => ({
                url: 'api/employees/employee/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'listprovider'
                }
            }),
            providesTags: ['TherapistList']
        }),

        getDiagnosesList: builder.query({
            query: (payload) => ({
                url: '/api/core/icd/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            })
        }),
        getDiagnosesICDFIlterList: builder.query({
            query: (payload) => ({
                url: '/api/core/icd/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list_by_icd_code'
                }
            })
        }),
        getAssessmentType: builder.query({
            query: (payload) => ({
                url: '/api/psychological-testing/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list_assessment_types'
                }
            })
        }),
        getActivity: builder.query({
            query: (payload) => ({
                url: '/api/psychological-testing/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list_activity_types'
                }
            })
        }),

        getAssessmentList: builder.query({
            query: (payload) => ({
                url: '/api/psychological-testing/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['assessment_list']
        }),

        getAssessmentDetail: builder.query({
            query: (payload) => ({
                url: '/api/psychological-testing/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['psychological_detail']
        }),

        addUpdateAssessment: builder.mutation({
            query: (payload) => ({
                url: '/api/psychological-testing/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: payload.id ? 'update' : 'create'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['assessment_list', 'psychological_detail'] : [])
        }),

        assessmentSign: builder.mutation({
            query: (payload) => ({
                url: '/api/psychological-testing/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'sign'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['assessment_list', 'psychological_detail', 'UnsignedReportsList'] : [])
        }),
        assessmentDelete: builder.mutation({
            query: (payload) => ({
                url: '/api/psychological-testing/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'delete'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['assessment_list'] : [])
        }),
        unlockAssessment: builder.mutation({
            query: (payload) => ({
                url: '/api/psychological-testing/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'unlock'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['assessment_list', 'psychological_detail'] : [])
        }),
        getPsychologyAssessmentHistory: builder.query({
            query: (payload) => ({
                url: '/api/psychological-testing/activity/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            }),
            invalidatesTags: ['PsychologyHistory']
        })
    })
});

export const {
    useGetAssessmentListQuery,
    useGetDiagnosesListQuery,
    useGetDiagnosesICDFIlterListQuery,

    useGetAssessmentTypeQuery,
    useGetPatientLocationQuery,
    useAddUpdateAssessmentMutation,
    useGetActivityQuery,
    useGetAssessmentDetailQuery,
    useAssessmentSignMutation,
    useAssessmentDeleteMutation,
    useUnlockAssessmentMutation,
    useGetPsychologicalTherapistListQuery,
    useLazyGetPsychologyAssessmentHistoryQuery
} = pshychologicalAssessment;
